import { render, staticRenderFns } from "./RoleChange.vue?vue&type=template&id=1a8a3de5&scoped=true"
import script from "./RoleChange.vue?vue&type=script&lang=js"
export * from "./RoleChange.vue?vue&type=script&lang=js"
import style0 from "./RoleChange.vue?vue&type=style&index=0&id=1a8a3de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a3de5",
  null
  
)

export default component.exports